import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { handoutOverS1ChartConfig } from '../chartConfigs';

/**
 * Props for the HandoutOverS1Echarts component
 */
interface HandoutOverS1EchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Handout Over S1 Handover Success Rate Chart (LTE Site Level)
 * 
 * Displays S1 interface outgoing handover metrics:
 * - Handout Over S1 Success (count)
 * - Handout Over S1 Attempt (count)
 * - Handout Over S1 Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (handoutOverS1ChartConfig)
 * @see API: /api/lte/handout-over-s1?site_name={siteName}
 */

const HandoutOverS1Echarts: React.FC<HandoutOverS1EchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={handoutOverS1ChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default HandoutOverS1Echarts;
